import { useQuery } from "@tanstack/react-query";
import { getSettings, getTestimonials, getEventThemes, getPress } from "../lib/api";
import { BRAND, TESTIMONIALS } from "../data/content";

// Site settings merged over static BRAND (keeps name/website, overrides contacts)
export const useSettings = () => {
  const { data } = useQuery({ queryKey: ["settings"], queryFn: getSettings, staleTime: 300000 });
  return { ...BRAND, ...(data || {}) };
};

export const useTestimonials = () => {
  const { data } = useQuery({ queryKey: ["testimonials"], queryFn: getTestimonials, staleTime: 300000 });
  return data && data.length ? data : TESTIMONIALS;
};

export const useEventThemes = () => {
  const { data } = useQuery({ queryKey: ["event-themes"], queryFn: getEventThemes, staleTime: 300000 });
  return data || [];
};

export const usePress = () => {
  const { data, isLoading } = useQuery({ queryKey: ["press"], queryFn: getPress, staleTime: 300000 });
  return { press: data || [], isLoading };
};
